import * as z from "zod";

export const disconnectOkendoMarketingIntegration = {
  name: "disconnectOkendoMarketingIntegration" as const,
  input: z.null(),
  output: z.null(),
};
